import React, { Fragment } from 'react';
import { inject } from 'mobx-react';

@inject('songsStore')
class SongListHeadings extends React.Component {
	render () {
		const { trackListMode } = this.props;

		if (trackListMode) {
			return (
				<div className="song-header-row song-row-tracks-header">
					<div className="song-row-tracks-header__play-spacer" aria-hidden="true" />

					<div className="song-row-tracks-header__track">
						<div className="section-title heading artist">Track</div>
					</div>

					<div className="song-row-tracks-header__listing">
						<div className="section-title heading artist">Listing</div>
						<div className="song-row-tracks-header__listing-hint">
							Explicit &amp; profile visibility
						</div>
					</div>

					<div className="song-row-tracks-header__status">
						<div className="section-title heading artist">Processing</div>
						<div className="song-row-tracks-header__status-hint">
							Upload &amp; encode
						</div>
					</div>

					<div className="song-row-tracks-header__actions">
						<div className="section-title heading artist show-for-medium">Actions</div>
					</div>

					{this.props.songsStore.showAdminOptions && this.renderEditorHeadings()}
				</div>
			);
		}

		return (
			<div className="grid-x song-header-row" style={{ justifyContent: 'space-between' }}>
				<div className="cell shrink">
					<div style={{ width: '2rem', height: '2.5rem' }}>
					</div>
				</div>

				<div className="cell small-7">
					<div className="section-title heading artist">Title</div>
				</div>

				<div className="cell small-1">
					<div className="section-title heading artist">Explicit</div>
				</div>

				<div className="cell text-center small-1">
					<div className="section-title heading artist">Active</div>
				</div>

				<div className="cell small-2">
					<div className="section-title heading artist">Status</div>
				</div>

				<div className="cell shrink">
				</div>

				{this.props.songsStore.showAdminOptions && this.renderEditorHeadings()}
			</div>
		);
	}

	renderEditorHeadings () {
		const { trackListMode } = this.props;

		if (trackListMode) {

			return null;
		}

		return (
			<Fragment>
				<div className="cell small-1 text-center">
					<strong>Explicit</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Plays</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Hi Fives</strong>
				</div>
			</Fragment>
		);
	}
}

export default SongListHeadings;
